/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

/**
 * 
 * @param {Question} question
 * @returns {*[]}
 */
export const validateTitleAndKey = (question) => {
    let errors = [];
    const type = question?.type;
    const key = question?.key;
    const label = question?.label ?? question?.prompt;
    // const guid = question?.guid;
    if (!label && !key) {
        errors.push(`Question "${key || type || ""}" requires label and key`);
    } else if (!key) {
        errors.push(`Question "${label || ""}" requires key`);
    } else if (!label) {
        errors.push(`Question "${key || type || ""}" requires label`);
    }
    return errors;
};


/** 
 * @param {Question} question
 * @return {*[]}
 * */
export const validateTitle = (question) => {
    const errors = [];
    const label = question?.label ?? question?.prompt;
    const type = question?.type;
    const key = question?.key;
    if (!label) {
        errors.push(`Question "${key || type || ""}" requires label`);
    }
    return errors;
};
